import { useSearchParams } from "react-router-dom";
import Chat from "../chat";
import ConversationRecords from "./ConversationRecords";

/** Thread URLs share the chat UI; the retained records view remains explicitly available. */
export default function Conversation() {
  const [params] = useSearchParams();
  return params.get("view") === "records" ? <ConversationRecords /> : <Chat />;
}
